module.exports = __webpack_public_path__ + "img/doctorpatient.b27884c4.jpg";